const siteTypes = {
  id: "siteTypes",
  label: "Site Types",
  endpoint: "site_types",
  columnConfig: [
    {
      field: "name",
      headerName: "Site Type",
      width: 250,
      description: "Site Type",
      editable: true,
    },
  ],
  hiddenColumns: ["id"],
  chipConfig: {},
  tagConfig: {},
};

export default siteTypes;
